export * from "-!../../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fr.vue?vue&type=template&id=ef311dfc"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-registration/fr.vue?vue&type=template&id=ef311dfc
// module id = 7nFn
// module chunks = 0